module.exports = __webpack_public_path__ + "img/logo-white.84a29aaa.png";